import { useLang } from "../context/LanguageContext";
import { useAIAssistant } from "../context/AIAssistantContext";
import { aiOrb } from "../assets";

export const AIAssistant = () => {
  const { t } = useLang();
  const { openAssistant } = useAIAssistant();

  return (
    <section
      id="ai-assistant"
      data-testid="ai-assistant-section"
      className="relative py-24 sm:py-32 overflow-hidden"
    >
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute -top-20 left-1/3 w-[520px] h-[520px] rounded-full bg-[#FF5A00]/12 blur-[120px]" />
      </div>

      <div className="relative max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-center">
          <div className="lg:col-span-7">
            <div className="eyebrow">{t.ai.eyebrow}</div>
            <h2
              data-testid="ai-title"
              className="mt-5 font-[Outfit] text-4xl sm:text-5xl lg:text-6xl font-light text-white leading-[1.05] tracking-tight"
            >
              {t.ai.title}
            </h2>
            <p className="mt-5 text-lg text-zinc-400 leading-relaxed max-w-2xl">
              {t.ai.subtitle}
            </p>

            <ul className="mt-8 space-y-3">
              {t.ai.bullets.map((b, i) => (
                <li
                  key={i}
                  className="flex items-start gap-3 text-sm text-zinc-200"
                >
                  <span className="mt-0.5 w-5 h-5 rounded-full bg-[#FF5A00]/15 text-[#FF5A00] inline-flex items-center justify-center shrink-0">
                    <i className="fa-solid fa-check text-[10px]" />
                  </span>
                  {b}
                </li>
              ))}
            </ul>

            <div className="mt-9 flex flex-wrap gap-3">
              <button
                data-testid="ai-cta-open"
                onClick={openAssistant}
                className="fk-btn fk-btn-primary"
              >
                <i className="fa-solid fa-wand-magic-sparkles" />
                {t.ai.ctaOpen}
              </button>
              <button
                data-testid="ai-cta-secondary"
                onClick={openAssistant}
                className="fk-btn fk-btn-secondary"
              >
                <i className="fa-solid fa-comments" />
                {t.ai.ctaSecondary}
              </button>
            </div>
          </div>

          {/* Orb visual */}
          <div className="lg:col-span-5">
            <div className="relative aspect-square w-full max-w-[440px] mx-auto">
              <div className="absolute inset-0 rounded-full bg-gradient-to-br from-[#FF5A00]/30 to-transparent blur-3xl" />
              <button
                onClick={openAssistant}
                data-testid="ai-orb"
                aria-label={t.ai.ctaOpen}
                className="relative w-full h-full rounded-full overflow-hidden fk-glass fk-glow group"
              >
                <img
                  src={aiOrb}
                  alt="AI"
                  className="w-full h-full object-cover opacity-90 group-hover:opacity-100 group-hover:scale-105 transition-all duration-700"
                  draggable={false}
                />
                <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
                  <div className="fk-glass rounded-full px-5 py-3 border border-[#FF5A00]/40 backdrop-blur-xl flex items-center gap-2 text-sm text-white">
                    <span className="w-2 h-2 rounded-full bg-emerald-400 animate-pulse" />
                    <span className="font-medium">{t.ai.ctaOpen}</span>
                  </div>
                </div>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
